import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { SectionLabel } from './ui/SectionLabel';
import { CornerFrame } from './ui/CornerFrame';
import { Check, X } from 'lucide-react';
export function Audience() {
  const isFor = ['High-performing professionals who cannot afford "down-time" in an unstable economy.', 'Protective parents who want a non-toxic, "First-Line" defense for their household.', 'Individuals who no longer trust centralized health systems and want total medical autonomy.', 'Biohackers looking for the missing "energy-link" between TCM and modern cellular health.'];
  const notFor = ['Those looking for a "magic pill" that requires no lifestyle adjustment.', 'People who are comfortable remaining entirely dependent on pharmacy shelves.', 'Anyone unwilling to take radical personal responsibility for their biological integrity.'];
  return <section className="py-14 md:py-16 bg-bio-dark border-y border-bio-gray/30" data-id="element-12">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-13">
        <FadeIn data-id="element-14">
          <div className="text-center mb-10" data-id="element-15">
            <div className="inline-block mb-3" data-id="element-16">
              <SectionLabel text="TARGET PROFILE // CLEARANCE CHECK" data-id="element-17" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-18">
              PROTOCOL SUITABILITY
            </h2>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-19">
          <FadeIn delay={0.1} data-id="element-20">
            <CornerFrame className="h-full !border-bio-teal/30" data-id="element-21">
              <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-22">
                <span className="text-bio-teal font-mono text-sm border border-bio-teal/50 px-2 py-1" data-id="element-23">
                  APPROVED
                </span>
                WHO THIS IS FOR
              </h3>
              <ul className="space-y-6" data-id="element-24">
                {isFor.map((text, i) => <li key={i} className="flex gap-4 items-start" data-id="element-25">
                    <Check className="w-5 h-5 text-bio-teal shrink-0 mt-1" data-id="element-26" />
                    <span className="text-bio-text font-light" data-id="element-27">{text}</span>
                  </li>)}
              </ul>
            </CornerFrame>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-28">
            <div className="relative border border-bio-gray/50 bg-bio-black p-8 h-full" data-id="element-29">
              <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3 opacity-80" data-id="element-30">
                <span className="text-bio-amber font-mono text-sm border border-bio-amber/50 px-2 py-1" data-id="element-31">
                  DENIED
                </span>
                WHO THIS IS NOT FOR
              </h3>
              <ul className="space-y-6 opacity-80" data-id="element-32">
                {notFor.map((text, i) => <li key={i} className="flex gap-4 items-start" data-id="element-33">
                    <X className="w-5 h-5 text-bio-amber shrink-0 mt-1" data-id="element-34" />
                    <span className="text-bio-muted font-light" data-id="element-35">{text}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}